import { Mark } from "@tiptap/core";

export const SelectionHighlightMark = Mark.create({
  name: "selectionHighlight",

  parseHTML() {
    return [{ tag: "span[data-selection-highlight]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      {
        ...HTMLAttributes,
        "data-selection-highlight": "true",
        class: "chartSelectionHighlight",
        style: "background-color: rgba(124, 58, 237, 0.18);"
      },
      0
    ];
  },

  addOptions() {
    return { ...this.parent?.(), spanning: true };
  },

  addMarkOptions() {
    return { ...this.parent?.(), spanning: true, inclusive: false };
  }
});
